/**
 * Send client-side errors to backend for logging
 * This helps debug issues on remote devices where console access is not available
 */

let apiRootUrl = null;
let accessToken = null;

export const setErrorLoggerConfig = (rootUrl, token) => {
  apiRootUrl = rootUrl;
  accessToken = token;
};

export const logErrorToBackend = async (error, context = {}) => {
  // Skip if we don't have API config yet
  if (!apiRootUrl || !accessToken) {
    return;
  }

  // Skip logging if it's a network error (to avoid infinite loops)
  if (error?.message?.includes('NETWORK_ERROR')) {
    return;
  }

  try {
    const errorLog = {
      message: error?.message || error?.toString() || 'Unknown error',
      stack: error?.stack,
      path: context.path,
      method: context.method,
      errorData: {
        data: error?.data,
        status: error?.status,
        ...context,
      },
      timestamp: new Date().toISOString(),
      userAgent: navigator.userAgent,
    };

    // Use fetch to avoid circular dependencies with saga
    await fetch(`${apiRootUrl}client-errors/log`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify(errorLog),
    });
  } catch (e) {
    // Silently fail - we don't want error logging to cause more errors
    console.debug('Failed to log error to backend:', e);
  }
};
